import React, { useState } from "react";
import { IconButton, Typography, makeStyles } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import TranscriptionIocn from "../assets/icons-transcription.png";
import PropTypes from "prop-types";
import Constant from "../helper/constant.json";

const useStyles = makeStyles({
  dialog: {
    position: "absolute",
    right: 10,
    bottom: 50,
    top: 10,
  },
  popUp: {
    position: "absolute",
    bottom: 3,
    right: 3,
  },
  closeBtn: {
    fontSize: "large",
  },
  transcribeText: {
    marginTop: "12px",
    marginRight: "20px",
  },
  transcribeDiv: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  disableTranscribeDiv: {
    display: "flex",
    flexDirection: "row",
    pointerEvents: "none",
    opacity: "0.4",
    justifyContent: "space-between",
  },
  transcribeMenu: {
    width: "12em",
    cursor: "pointer",
    display: "flex"
  },
});

function MoreMenu({
  setPopover,
  session,
  onStartTranscribe,
  onStopTranscribe,
  toggleTranscribe,
  onClosePopover
}) {
  const [ComponentName, setComponentname] = useState("");
  const [transcribeMenu, setTranscribeMenu] = useState(null);
  const classes = useStyles();

  const startTranscribe = () => {
    onStartTranscribe();
    onClosePopover()
  }

  return (
    <>
      <div className={classes.transcribeMenu}>
        <div
          className={
            session.session?._callState === "connected" &&
              !toggleTranscribe &&
              window.config?.featureFlags?.transcribe?.enable
              ? classes.transcribeDiv
              : classes.disableTranscribeDiv
          }
          onClick={startTranscribe}
        >
          <IconButton>
            <img width="23px" height="23px" src={TranscriptionIocn} />
          </IconButton>
          <Typography className={classes.transcribeText}>
            {Constant.Transcribe}
          </Typography>
        </div>
        <IconButton>
          <Close className={classes.closeBtn} onClick={onClosePopover} />
        </IconButton>
      </div>

      {/* {ComponentName === "transcribe" && (
        <Popover
          open={Boolean(transcribeMenu)}
          anchorEl={transcribeMenu}
          onClose={() => {
            setTranscribeMenu(null);
          }}
          style={{ marginLeft: "-1rem" }}
          // onClose={() => handleDevicePopOverClose()}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Transcribe
            setTranscribeMenu = {setTranscribeMenu}
            session={session}
            onStartTranscribe={onStartTranscribe}
            onStopTranscribe={onStopTranscribe}
            toggleTranscribe={toggleTranscribe}
          />
        </Popover>
      )}  */}
    </>
  );
}

MoreMenu.propTypes = {
  setPopover: PropTypes.any,
  session: PropTypes.any,
  onStartTranscribe: PropTypes.any,
  onStopTranscribe: PropTypes.any,
  toggleTranscribe: PropTypes.any,
  onClosePopover: PropTypes.any
};

export default MoreMenu;
